import { render, staticRenderFns } from "./novel_chapter.vue?vue&type=template&id=270522e4&scoped=true"
import script from "./novel_chapter.vue?vue&type=script&lang=js"
export * from "./novel_chapter.vue?vue&type=script&lang=js"
import style0 from "./novel_chapter.vue?vue&type=style&index=0&id=270522e4&prod&scoped=true&lang=css"
import style1 from "./novel_chapter.vue?vue&type=style&index=1&id=270522e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270522e4",
  null
  
)

export default component.exports